// @ts-nocheck
export const generateRotationValues = (spikesCount: number) => {
	return getRotationValuesSTW1(spikesCount)
}

const getRotationValuesSTW1 = (spikesCount: number) => {
	let rotationValuesTemp = [];
		let segmentAngle = 360 / spikesCount;
		let firstHalfSegement = {
			minDegree: 0,
			maxDegree: segmentAngle / 2,
			value: 1
		};
		rotationValuesTemp.push(firstHalfSegement);
		for (let i = spikesCount; i >= 2; i--) {
			const lastValue = rotationValuesTemp[rotationValuesTemp.length - 1];
			const currentSegmentValue = {
				minDegree: lastValue.maxDegree + 1,
				maxDegree: lastValue.maxDegree + segmentAngle,
				value: i
			};
			rotationValuesTemp.push(currentSegmentValue);
		}
		const lastValue = rotationValuesTemp[rotationValuesTemp.length - 1];
		let secondHalfSegement = {
			minDegree: lastValue.maxDegree + 1,
			maxDegree: lastValue.maxDegree + (segmentAngle / 2),
			value: 1
		};
		rotationValuesTemp.push(secondHalfSegement);
		return rotationValuesTemp;
}

export const colorLuminance = (hex, lum) => {
    hex = String(hex).replace(/[^0-9a-f]/gi, "");
    if (hex.length < 6) {
      hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }
    lum = lum || 0;
    let rgb = "#",
      c,
      i;
    for (i = 0; i < 3; i++) {
      c = parseInt(hex.substr(i * 2, 2), 16);
      c = Math.round(Math.min(Math.max(0, c + c * lum), 255)).toString(16);
      rgb += ("00" + c).substr(c.length);
    }
    return rgb;
};

export const getRgbColor = (color: string) => {
    // Convert the color to an RGB color using a temporary DOM element
    const tempElem = document.createElement('div');
    tempElem.style.color = color;
    document.body.appendChild(tempElem);
    const rgbColor = window.getComputedStyle(tempElem).color;
    document.body.removeChild(tempElem);

    // Parse the RGB values from the color string
    const match = rgbColor.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
    return match
      ? { r: +match[1], g: +match[2], b: +match[3] }
      : { r: 0, g: 0, b: 0 };
  };


 export const getContrastColor = (bgColor: string) => {
    // Convert the background color to an RGB color
    const color = getRgbColor(bgColor);

    // Calculate the relative luminance of the color using the sRGB color space formula
    const luminance = 0.2126 * color.r + 0.7152 * color.g + 0.0722 * color.b;
    // Choose white or black as the text color based on the luminance value
    if (luminance > 100) {
      return '#212121';
    } else {
      return '#FFFFFF';
    }
  };


export const getScrollPercent = () => {
	var winHeight = window.innerHeight;
	var docHeight = document.body.clientHeight;
	var scrollTop = window.scrollY;
	var trackLength = docHeight - winHeight;
	var pctScrolled = Math.floor(scrollTop / trackLength * 100);
	return pctScrolled;
};
export const segmentHeightMap = {
	
	
		previewMobile: 87,
		previewDesktop: 62,
		defaultHeightDesktop: 180,
		defaultHeightMobile: 148
	
   
}
export const updateSegmentWidth = (spikesCount: number) => {
	let segmentHeight = null
	
		if (window.screen.width > 768) {
			segmentHeight = segmentHeightMap.defaultHeightDesktop;
		} else {
			segmentHeight = segmentHeightMap.defaultHeightMobile;
		}
	
	const width = Math.tan(((360 / (spikesCount * 2)) * Math.PI) / 180) * segmentHeight * 2;
	return width
}

export const getSegmentDetails = (spikesCount: number, segmentColor1: string, segmentColor2: string, discountCodeTitle) => {
    const segmentDegree = 360 / spikesCount;
	let wheelDetails = [];
	for (let i = 0; i < spikesCount; i++) {
		wheelDetails = [
		  ...wheelDetails,
		  getRotationValues(i, segmentDegree, discountCodeTitle),
		];
	}
	for (let i = 0; i < spikesCount; i = i + 2) {
		wheelDetails[i] = {
		  ...wheelDetails[i],
		  color: segmentColor1,
		};
		wheelDetails[i + 1] = {
		  ...wheelDetails[i + 1],
		  color: segmentColor2,
		};
	  }
	return wheelDetails;
}

export const getRotationValues = (idx: number, segmentDegree: number, discountCodeTitle) => {
  let obj = {};
  switch (idx) {
    case 0:
      return (obj = {
        class: 'one',
        text: (discountCodeTitle && discountCodeTitle[1]) ? discountCodeTitle[1] : '₹200 Off on ₹2500',
        rotationValue: segmentDegree * idx,
      });

    case 1:
      return (obj = {
        class: 'two',
        text: (discountCodeTitle && discountCodeTitle[2]) ? discountCodeTitle[2] : '₹500 Off on 4K(Only on App)',
        rotationValue: segmentDegree * idx,
      });

    case 2:
      return (obj = {
        class: 'three',
        text: (discountCodeTitle && discountCodeTitle[3])? discountCodeTitle[3] : '₹400 Off on 5K',
        rotationValue: segmentDegree * idx,
      });

    case 3:
      return (obj = {
        class: 'four',
        text: (discountCodeTitle &&  discountCodeTitle[4]) ? discountCodeTitle[4] : '₹1000 Off on 12K',
        rotationValue: segmentDegree * idx,
      });
    case 4:
      return (obj = {
        class: 'five',
        text: (discountCodeTitle &&  discountCodeTitle[5]) ? discountCodeTitle[5] : 'Flat ₹1000 Off(Only on App)',
        rotationValue: segmentDegree * idx,
      });

    case 5:
      return (obj = {
        class: 'six',
        text: (discountCodeTitle && discountCodeTitle[6]) ? discountCodeTitle[6] : 'Free Shipping',
        rotationValue: segmentDegree * idx,
      });

    case 6:
      return (obj = {
        class: 'seven',
        text: (discountCodeTitle && discountCodeTitle[7]) ? discountCodeTitle[7] :'Flat 70% off',
        rotationValue: segmentDegree * idx,
      });
    case 7:
      return (obj = {
        class: 'eight',
        text: (discountCodeTitle && discountCodeTitle[8]) ? discountCodeTitle[8] :'Flat 80% off',
        rotationValue: segmentDegree * idx,
      });
    case 8:
      return (obj = {
        class: 'nine',
        text: (discountCodeTitle && discountCodeTitle[9]) ? discountCodeTitle[9] :'Flat 90% off',
        rotationValue: segmentDegree * idx,
      });
    case 9:
      return (obj = {
        class: 'ten',
        text: (discountCodeTitle && discountCodeTitle[10]) ? discountCodeTitle[10] :'Flat 100% off',
        rotationValue: segmentDegree * idx,
      });
  }
}

export const getLocationParams = (href) => {
	var match = href.match(/^(https?\:)\/\/(([^:\/?#]*)(?:\:([0-9]+))?)([\/]{0,1}[^?#]*)(\?[^#]*|)(#.*|)$/, );
	return (match && {
		href: href,
		protocol: match[1],
		host: match[2],
		hostname: match[3],
		port: match[4],
		pathname: match[5],
		search: match[6],
		hash: match[7],
	});
};

export const addDiscountText = (discountCodeTitle, segmentDetails) => {
	let wheelDetails = [...segmentDetails];
    wheelDetails.map((desc, index) => {
      const respectiveDiscountCodeDataKey = Object.keys(discountCodeTitle).filter(
        key => key === (index + 1).toString(),
      );
      if (respectiveDiscountCodeDataKey) {
        wheelDetails[index] = {
          ...wheelDetails[index],
          text: discountCodeTitle[respectiveDiscountCodeDataKey[0]],
        };
      }
    });
	return wheelDetails
}